import { render } from "./UploadDocsModal.vue?vue&type=template&id=37881bc8"
import script from "./UploadDocsModal.vue?vue&type=script&lang=js"
export * from "./UploadDocsModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__